import React from 'react';
import { SEOTableColumn, TableConfig } from 'src/api/models/SEOTable';
import { ContentCell, EmptyCell, HeadCell, ContentGrid, TitleCell } from './Cell.styles';
import { setColor } from 'app_previous/styles/colors';
import Paragraph from 'app_previous/elements/typography/paragraph';
import CellEntry from './CellEntry';
import AnchorToController from './AnchorToController';

interface CellProps extends SEOTableColumn, TableConfig {
  isEmpty?: boolean;
  isHead?: boolean;
  isTitle?: boolean;
  rowIndex: number;
  className?: string;
  entries?: SEOTableColumn[];
}

export const getCellTemplateColumns = (firstColumnCustomWidth: number, columnCount: number): string => {
  if (firstColumnCustomWidth) {
    return `${firstColumnCustomWidth}px repeat(${columnCount - 1}, 1fr)`;
  }

  return `repeat(${columnCount}, 1fr)`;
};

const Cell = ({
  isEmpty = false,
  borderColor,
  backgroundColorSet,
  rowIndex,
  isHead = false,
  text,
  textColor,
  className,
  entries,
  isTitle = false,
  checkIconSet,
  anchorTo,
}: CellProps): JSX.Element => {
  const cellBackgroundColor = rowIndex % 2 !== 0 ? backgroundColorSet[1] : backgroundColorSet[0];

  const configProps = {
    borderColor,
    backgroundColor: cellBackgroundColor,
    checkIconSet,
    className,
    textColor,
  };

  if (isEmpty) {
    return (
      <EmptyCell
        {...configProps}
        as={isHead ? 'th' : 'td'}
      />
    );
  }

  if (isHead) {
    return (
      <HeadCell {...configProps}>
        <Paragraph
          text={text}
          align='center'
          standardSize='1'
          weight={700}
          color={setColor(textColor)}
        />
      </HeadCell>
    );
  }

  if (isTitle) {
    return (
      <TitleCell {...configProps}>
        <AnchorToController anchorTo={anchorTo}>
          <Paragraph
            text={text}
            align='left'
            weight={700}
            standardSize='1'
            color={setColor(textColor)}
          />
        </AnchorToController>
      </TitleCell>
    );
  }

  return (
    <ContentCell {...configProps}>
      <ContentGrid>
        {entries?.map((entry, index) => (
          <CellEntry
            key={index}
            {...configProps}
            {...entry}
          />
        ))}
      </ContentGrid>
    </ContentCell>
  );
};

export default Cell;
